import type { NavbarStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

const navbar: NavbarStyles = {
  navbar: {
    padding: '1rem 1rem 0.5rem 1rem !important',
    '${min.sm}': {
      padding: '1rem calc(1rem + 15px) !important',
    },
    '${min.md}': {
      padding: '1.5rem calc(1rem + 15px) !important',
    },
    '.nav-link': {
      textDecoration: 'none',
      color: `${colors.headerText} !important`,
      fontWeight: fonts.fontWeights.bold,
      fontSize: '14px',
      '&.active, &:hover': {
        color: `${colors.primary}`,
      },
    },
    '.navbar-toggler .icon-bar': {
      background: `${colors.white} !important`,
    },
    '.onboarding-nav-container & .nav-link:hover': {
      color: `${colors.white}`,
      opacity: 0.6,
    },
    '.theme-logo': {
      flex: 'auto',
      'justify-content': 'inherit',
      display: 'block',
      paddingLeft: 'inherit',
      '${min.sm}': {
        flex: 'auto',
        'justify-content': 'inherit',
        display: 'block',
        paddingLeft: '0',
      },
      '${min.lg}': {
        display: 'block',
        paddingLeft: '0',
      },
    },
  },
  headerBackground: colors.gradients.header,
  logoPath: '/images/loop-optimise-logo-white.svg',
  headerBorder: 'none',
  mainNavIcons: {
    today: 'overview',
    savings: 'finance',
    energyFlow: 'elec',
    tariffRecommender: 'tariff',
    turnDownAndSave: 'tdas',
    settings: 'settings',
    help: 'help',
  },
  onboarding: {
    '${min.lg}': {
      borderBottom: 'inherit',
      background: 'inherit',
    },
    '.theme-logo': {
      '${min.lg}': {
        display: 'inherit',
      },
      '${min.md}': {
        display: 'inherit',
      },
      '${min.sm}': {
        display: 'inherit',
      },
    },
  },
  container: {
    '${min.md}': {
      justifyContent: 'space-between',
    },
  },
};

export default navbar;
